<section>
    <div class="container">
        <div class="row row-fit-lg fade-bottom" style="position: relative;
        animation-duration: 1000ms;
        transition-timing-function: ease;
        transition-delay: 0ms;">
            <div class="col-lg-6" style="margin-bottom: 30px;">
                <div style="padding-top: 56.25%; background-size: cover; background-image: url('assets/image-16.webp');">
                </div>
            </div>
            <div class="col-lg-6">
                <div class="title">
                    <h2 class="text-primary">Our values and goals</h2>
                    <p class="text-secondary">About us</p>
                </div>
                <p style="color: rgb(64, 77, 96);">
                    1artifactware was established following almost ten years of expert software development.
                    The company was founded in order to be able to take on more significant projects that required
                    greater organization and more resources than a single freelance coder could offer.
                </p>
                <div class="box-sign">
                    <b>1ARTIFACTWARE</b>
                    <span>Custom Business Software</span>
                </div>
            </div>
        </div>
    </div>
</section>